import React from "react";

interface ButtonGroupOrganizerProps {
    children: React.ReactNode;
}

const ButtonGroupOrganizer: React.FC<ButtonGroupOrganizerProps> = ({
                                                                       children,
                                                                   }) => {
    return (
        <div className="flex space-x-4">
            {children}
        </div>
    );
};

export default ButtonGroupOrganizer;
